import { baseApi } from "./baseApi";
import { SignUpRequest } from "../models/api/auth/signUpRequest";
import { ResponseResult } from "../models/api/responseResult";
import { ConfirmEmailRequest } from "../models/api/confirmEmailRequest";
import { ResetPasswordRequest } from "../models/api/auth/resetPasswordRequest";
import { ErrorResponse } from "../models/api/errorResponse";
import { UserProfileData } from "../models/api/user/userProfileData";
import { ChangePasswordRequest } from "../models/api/auth/changePasswordRequest";

export const userApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        createUser: builder.mutation<ResponseResult | ErrorResponse, SignUpRequest>({
            query(body) {
                return {
                    url: `${import.meta.env.VITE_USER}`,
                    method: "POST",
                    body,
                };
            },
        }),
        confirmEmail: builder.query<ResponseResult | ErrorResponse, ConfirmEmailRequest>({
            query: (params) => {
                return {
                    url: `${import.meta.env.VITE_CONFIRM_EMAIL}`,
                    params,
                };
            },
        }),
        forgotPassword: builder.mutation<ResponseResult | ErrorResponse, { email: string }>({
            query: (body) => {
                return {
                    url: `${import.meta.env.VITE_FORGOT_PASSWORD}`,
                    method: "POST",
                    body,
                };
            },
        }),
        resetPassword: builder.mutation<ResponseResult | ErrorResponse, ResetPasswordRequest>({
            query: (body) => {
                return {
                    url: `${import.meta.env.VITE_RESET_PASSWORD}`,
                    method: "POST",
                    body,
                };
            },
        }),
        changePassword: builder.mutation<ResponseResult | ErrorResponse, ChangePasswordRequest>({
            query: (body) => {
                return {
                    url: `${import.meta.env.VITE_CHANGE_PASSWORD}`,
                    method: "POST",
                    body,
                };
            },
        }),
        getUserProfile: builder.query<UserProfileData, void>({
            query: () => {
                return {
                    url: `${import.meta.env.VITE_USER_PROFILE}`,
                };
            },
            providesTags: ["userProfile"],
        }),
        updateUserProfile: builder.mutation<ResponseResult | ErrorResponse, UserProfileData>({
            query: (body) => {
                return {
                    url: `${import.meta.env.VITE_USER_PROFILE}`,
                    method: "PATCH",
                    body,
                };
            },
            invalidatesTags: ["userProfile", "session"],
        }),
    }),
});

export const {
    useCreateUserMutation,
    useLazyConfirmEmailQuery,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useChangePasswordMutation,
    useGetUserProfileQuery,
    useUpdateUserProfileMutation,
} = userApi;
